import React, { useEffect, useState } from "react";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import { Header } from "../../../components/header/Header";
import { PageHeader } from "../../../components/header/PageHeader";
import FormContainer from "../../../components/form/FormContainer";
import { useApiClient } from "../../../shared/customHooks";
import { externalApplicationRequestForm } from "../../../shared/formObjects/external/externalApplicationRequestForm";
import { useNavigate } from "react-router";

export default function CreateLegacyApplication() {
  const { setHeaderText } = useApplicationContext();
  const externalEvidenceApi = useApiClient("ExternalInitialApplication/PostApplication");
  const [formContext] = useState();
  const navigate = useNavigate();

  const headerText = [
    {
      class: "flex align-center mt-0",
      value: "Create new application",
      icon: "view-app-icon mr-3 mt-0",
    },
  ];

  useEffect(() => {
    setHeaderText({
      value: "Edit Kindergarten Details",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  const handleSUccess = () => {
    navigate("/applicationsLegacy");
  };

  return (
    <>
      <Header />
      <PageHeader headerText={headerText} icon={"icon"} />
      <FormContainer
        apiClient={externalEvidenceApi}
        formBody={externalApplicationRequestForm}
        formTitle=""
        formContext={formContext}
        saveSuccessCB={handleSUccess}
        showInternalNotes={false}
        submitBtnTitle="Submit"
      />
    </>
  );
}
